<template>
  <div id="ShadowQualityRequestPopup">
    <div class="common_view_tit">요청자 정보</div>
    <div class="common_view_list">
      <div class="common_view_item">
        <div>
          <div>작성자</div>
          <div>
            <template v-if="originData.userName != null">{{originData.userName}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>본부</div>
          <div>
            <template v-if="originData.affiliateCode != null">
              <template v-for="afc in afcList" v-if="afc.codeValue === originData.affiliateCode">{{afc.codeName}}</template>
            </template>
            <template v-if="originData.officeCode != null">
              <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (originData.officeCode.length === 5 ? originData.officeCode : originData.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              <template v-if="originData.officeCode.length > 5">
                <template v-for="ofc2 in ofc2List" v-if="ofc2.codeValue === originData.officeCode">{{ofc2.codeName}}</template>
              </template>
            </template>
            <template v-if="originData.affiliateCode == null && originData.officeCode == null">-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>전화번호</div>
          <div>
            <template v-if="originData.telephone != null">{{originData.telephone}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>이동전화번호</div>
          <div>
            <template v-if="originData.mobilePhone != null">{{originData.mobilePhone}}</template>
            <template v-else>-</template>
          </div>
        </div>
      </div>
    </div>
    <div class="common_view_tit">요청모뎀 정보<span class="fc_red">*</span></div>
    <div class="common_view_list type_form">
      <div class="common_view_item">
        <div>
          <div>모델명</div>
          <div>
            <input type="text" class="type_form_width_75" :value="originData.modelName" readonly/>
            <span>* 수정불가</span>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>모델번호</div>
          <div>
            <input type="text" class="type_form_width_75" :value="originData.serialNum" readonly/>
            <span>* 수정불가</span>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>기기번호(계량기 번호)<span class="fc_red">*</span></div>
          <div>
            <input type="text" class="type_form_width_75" v-model="meterNum" :readonly="mySession.userRole !== 2"/>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>요청구분<span class="fc_red">*</span></div>
          <div>
            <select class="type_form_width_75" v-model="requestType" :disabled="mySession.userRole !== 2">
              <option value="">-- 선택 --</option>
              <option v-for="item in srtList" :key="'sqrt_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>현장담당자(이름)<span class="fc_red">*</span></div>
          <div>
            <input type="text" class="type_form_width_75" v-model="siteMngName" :readonly="mySession.userRole !== 2"/>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>현장담당자 연락처<span class="fc_red">*</span></div>
          <div>
            <input type="text" class="type_form_width_75" v-model="siteMngContract" :readonly="mySession.userRole !== 2"/>
            <span>예) 010-1111-1111</span>
          </div>
        </div>
      </div>
      <div class="common_view_item type_address">
        <div>
          <div>주소<span class="fc_red">*</span></div>
          <div>
            <span style="margin-left: 0; font-weight: 700;">※ "주소 검색" 기능을 이용해 우편번호, 도로명주소, 지번주소를 선택 후 상세주소만 입력하십시요.</span>
          </div>
        </div>
        <div>
          <div>
            <div class="btn_inner_blue" v-if="mySession.userRole === 2" @click="showPostcodePopup">주소 검색</div>
          </div>
          <div>
            <div>
              <input type="text" v-model="postalCode" readonly/>
              <input type="text" v-model="addressRoad" readonly/>
            </div>
            <div>
              <input type="text" v-model="addressLot" readonly/>
            </div>
            <div>
              <input type="text" v-model="addressDetails" :readonly="mySession.userRole !== 2"/>
            </div>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>상호/건물명<span class="fc_red">*</span></div>
          <div>
            <input type="text" class="type_form_width_75" v-model="buildingName" :readonly="mySession.userRole !== 2"/>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>모뎀위치<span class="fc_red">*</span></div>
          <div>
            <select class="type_form_width_50" v-model="modemPos" :disabled="mySession.userRole !== 2">
              <option value="">-- 선택 --</option>
              <option value="1">옥내</option>
            </select>
            <span>! 옥내만 가능하며 그외 접수 불가 !</span>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>수신레벨</div>
          <div>
            <select class="type_form_width_50" v-model="signalLevel" :disabled="mySession.userRole !== 2">
              <option value="">-- 선택 --</option>
              <option v-for="item in signalLevelList" :key="'sqsl_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
            <span>dbm</span>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>계량기 상세 위치<span class="fc_red">*</span></div>
          <div>
            <input type="text" class="type_form_width_50" v-model="meterPos" :readonly="mySession.userRole !== 2"/>
            <span>구체적으로 기재(예:지하1층 벽면, 복도 등)</span>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>RSRP</div>
          <div>
            <input type="text" v-model="rsrp" :readonly="mySession.userRole !== 2"/>
          </div>
        </div>
      </div>
<!--      <div class="common_view_item">-->
<!--        <div>-->
<!--          <div>RSRP</div>-->
<!--          <div class="type_attachment">-->
<!--            <span style="margin: 7px 0 0 0; font-weight: 700;">-->
<!--              ※ KAMI의 통신세기 정보이며 차세대 고압 원격검침 시스템 스크린샷 사진<br>-->
<!--              - 이미지 파일(jpg, gif, png) 최대5개 등록 가능-->
<!--            </span>-->
<!--            <div class="common_form_input_wrap type_file">-->
<!--              <div>-->
<!--                <div>첨부파일1</div>-->
<!--                <div>-->
<!--                  <template v-if="rsrp1Origin != null && rsrp1Origin.length > 0">{{rsrp1Origin}}</template>-->
<!--                  <template v-else>첨부파일 없음</template>-->
<!--                </div>-->
<!--              </div>-->
<!--              <input type="file" id="rsrp1" ref="rsrp1" @change="uploadFile('rsrp1')" accept=".jpg, .jpeg, .gif, .png"/>-->
<!--              <template v-if="mySession.userRole === 2">-->
<!--                <label for="rsrp1" class="btn_upload">파일 첨부</label>-->
<!--                <label class="btn_delete" @click="deleteFile('rsrp1')">첨부 삭제</label>-->
<!--              </template>-->
<!--              <label class="btn_download" v-else @click="downloadFile('/upload/rsrp/' + rsrp1)">다운로드</label>-->
<!--            </div>-->
<!--            <div class="common_form_input_wrap type_file">-->
<!--              <div>-->
<!--                <div>첨부파일2</div>-->
<!--                <div>-->
<!--                  <template v-if="rsrp2Origin != null && rsrp2Origin.length > 0">{{rsrp2Origin}}</template>-->
<!--                  <template v-else>첨부파일 없음</template>-->
<!--                </div>-->
<!--              </div>-->
<!--              <input type="file" id="rsrp2" ref="rsrp2" @change="uploadFile('rsrp2')" accept=".jpg, .jpeg, .gif, .png"/>-->
<!--              <template v-if="mySession.userRole === 2">-->
<!--                <label for="rsrp2" class="btn_upload">파일 첨부</label>-->
<!--                <label class="btn_delete" @click="deleteFile('rsrp2')">첨부 삭제</label>-->
<!--              </template>-->
<!--              <label class="btn_download" v-else @click="downloadFile('/upload/rsrp/' + rsrp2)">다운로드</label>-->
<!--            </div>-->
<!--            <div class="common_form_input_wrap type_file">-->
<!--              <div>-->
<!--                <div>첨부파일3</div>-->
<!--                <div>-->
<!--                  <template v-if="rsrp3Origin != null && rsrp3Origin.length > 0">{{rsrp3Origin}}</template>-->
<!--                  <template v-else>첨부파일 없음</template>-->
<!--                </div>-->
<!--              </div>-->
<!--              <input type="file" id="rsrp3" ref="rsrp3" @change="uploadFile('rsrp3')" accept=".jpg, .jpeg, .gif, .png"/>-->
<!--              <template v-if="mySession.userRole === 2">-->
<!--                <label for="rsrp3" class="btn_upload">파일 첨부</label>-->
<!--                <label class="btn_delete" @click="deleteFile('rsrp3')">첨부 삭제</label>-->
<!--              </template>-->
<!--              <label class="btn_download" v-else @click="downloadFile('/upload/rsrp/' + rsrp3)">다운로드</label>-->
<!--            </div>-->
<!--            <div class="common_form_input_wrap type_file">-->
<!--              <div>-->
<!--                <div>첨부파일4</div>-->
<!--                <div>-->
<!--                  <template v-if="rsrp4Origin != null && rsrp4Origin.length > 0">{{rsrp4Origin}}</template>-->
<!--                  <template v-else>첨부파일 없음</template>-->
<!--                </div>-->
<!--              </div>-->
<!--              <input type="file" id="rsrp4" ref="rsrp4" @change="uploadFile('rsrp4')" accept=".jpg, .jpeg, .gif, .png"/>-->
<!--              <template v-if="mySession.userRole === 2">-->
<!--                <label for="rsrp4" class="btn_upload">파일 첨부</label>-->
<!--                <label class="btn_delete" @click="deleteFile('rsrp4')">첨부 삭제</label>-->
<!--              </template>-->
<!--              <label class="btn_download" v-else @click="downloadFile('/upload/rsrp/' + rsrp4)">다운로드</label>-->
<!--            </div>-->
<!--            <div class="common_form_input_wrap type_file">-->
<!--              <div>-->
<!--                <div>첨부파일5</div>-->
<!--                <div>-->
<!--                  <template v-if="rsrp5Origin != null && rsrp5Origin.length > 0">{{rsrp5Origin}}</template>-->
<!--                  <template v-else>첨부파일 없음</template>-->
<!--                </div>-->
<!--              </div>-->
<!--              <input type="file" id="rsrp5" ref="rsrp5" @change="uploadFile('rsrp5')" accept=".jpg, .jpeg, .gif, .png"/>-->
<!--              <template v-if="mySession.userRole === 2">-->
<!--                <label for="rsrp5" class="btn_upload">파일 첨부</label>-->
<!--                <label class="btn_delete" @click="deleteFile('rsrp5')">첨부 삭제</label>-->
<!--              </template>-->
<!--              <label class="btn_download" v-else @click="downloadFile('/upload/rsrp/' + rsrp5)">다운로드</label>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="common_view_item">
        <div>
          <div>KAMI</div>
          <div class="type_attachment">
            <span style="margin: 7px 0 0 0; font-weight: 700;">
              ※ KAMI 정보의 LP 엑셀 파일이며 7일치의 데이터를 올려야함
            </span>
            <div class="common_form_input_wrap type_file">
              <div>
                <div>첨부파일1</div>
                <div>
                  <template v-if="kamiOrigin != null && kamiOrigin.length > 0">{{kamiOrigin}}</template>
                  <template v-else>첨부파일 없음</template>
                </div>
              </div>
              <input type="file" id="kami" ref="kami" @change="uploadFile('kami')" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
              <template v-if="mySession.userRole === 2">
                <label for="kami" class="btn_upload">파일 첨부</label>
                <label class="btn_delete" @click="deleteFile('kami')">첨부 삭제</label>
              </template>
              <label class="btn_download" v-else @click="downloadFile('/upload/kami/' + kami)">다운로드</label>
            </div>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>건물주/담당자 특이사항</div>
          <div>
            <input type="text" v-model="ownerMemo" :readonly="mySession.userRole !== 2"/>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>건물 담당자 연락처</div>
          <div>
            <input type="text" class="type_form_width_75" v-model="ownerContact" :readonly="mySession.userRole !== 2"/>
            <span>예)010-1111-1111</span>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>문제점 및 현상</div>
          <div>
            <select class="type_form_width_50" v-model="issueCode" :disabled="mySession.userRole !== 2">
              <option value="">-- 선택 --</option>
              <option v-for="item in iscList" :key="'sqpt_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="common_view_item">
        <div>
          <div>기타사항</div>
          <div>
            <textarea v-model="etcMemo" :readonly="mySession.userRole !== 2"/>
          </div>
        </div>
      </div>
    </div>
    <div class="common_bottom_wrap padding_wrap">
      <div class="btn_bottom btn_close" @click="hidePopup">닫기</div>
      <div class="btn_bottom btn_blue_t" @click="saveShadowQuality" v-if="popupParams.type === 'R' && mySession.userRole === 2">등록(선택)</div>
    </div>
    <modal name="postcodePopup" :width="400" height="auto">
      <vue-daum-postcode @complete="setAddress"/>
    </modal>
  </div>
</template>

<script>
import common from '../../script/common'
import shadowQuality from '../../script/shadowQuality'
import {VueDaumPostcode} from 'vue-daum-postcode'
import axios from 'axios'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  components: {VueDaumPostcode},
  props: ['popupParams'],
  data () {
    return {
      // Common
      mySession: {},
      // Return
      searchParams: {},
      // Common Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      ofc2List: [],
      srtList: [],
      signalLevelList: common.getSQSignalLevelList(),
      attachmentTypes: ['rsrp1', 'rsrp2', 'rsrp3', 'rsrp4', 'rsrp5', 'kami'],
      iscList: [],
      // Data
      originData: {},
      requestIssue: '',
      sqPid: null,
      modemPid: '',
      meterNum: '',
      requestType: '',
      siteMngName: '',
      siteMngContract: '',
      postalCode: '',
      addressRoad: '',
      addressLot: '',
      addressDetails: '',
      buildingName: '',
      modemPos: '',
      signalLevel: '',
      meterPos: '',
      rsrp: '',
      // rsrp1Origin: '',
      // rsrp1: '',
      // rsrp2Origin: '',
      // rsrp2: '',
      // rsrp3Origin: '',
      // rsrp3: '',
      // rsrp4Origin: '',
      // rsrp4: '',
      // rsrp5Origin: '',
      // rsrp5: '',
      kamiOrigin: '',
      kami: '',
      ownerMemo: '',
      ownerContact: '',
      issueCode: '',
      etcMemo: ''
    }
  },
  mounted () {
    this.originData = this.popupParams.data
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('srtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('iscList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            if (this.originData.officeCode != null && this.originData.officeCode.length > 5) {
              this.getOfc2List()
            }
            this.srtList = JSON.parse(sessionStorage.getItem('srtList'))
            this.iscList = JSON.parse(sessionStorage.getItem('iscList'))
            this.updateData()
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  watch: {
    popupParams () {
      this.originData = this.popupParams.data
    }
  },
  methods: {
    hidePopup (args) {
      this.$emit('hidePopup', args)
    },
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    getOfc2List () {
      this.ofc2List = this.ofcList.filter(item => { return item.codeParent === this.originData.officeCode.substring(0, 5) })
    },
    updateData () {
      console.log('updateData', this.popupParams.data)
      const data = this.popupParams.data
      if (!data.hasOwnProperty('sqPid') || data.sqPid == null) {
        return
      }
      this.sqPid = data.sqPid
      this.modemPid = data.modemPid != null ? data.modemPid : ''
      this.meterNum = data.meterNum != null ? data.meterNum : ''
      this.requestType = data.requestType != null ? data.requestType : ''
      this.siteMngName = data.siteMngName != null ? data.siteMngName : ''
      this.siteMngContract = data.siteMngContract != null ? data.siteMngContract : ''
      this.postalCode = data.postalCode != null ? data.postalCode : ''
      this.addressRoad = data.addressRoad != null ? data.addressRoad : ''
      this.addressLot = data.addressLot != null ? data.addressLot : ''
      this.addressDetails = data.addressDetails != null ? data.addressDetails : ''
      this.buildingName = data.buildingName != null ? data.buildingName : ''
      this.modemPos = data.modemPos != null ? data.modemPos : ''
      this.signalLevel = data.signalLevel != null ? data.signalLevel : ''
      this.meterPos = data.meterPos != null ? data.meterPos : ''
      this.rsrp = data.rsrp != null ? data.rsrp : ''
      // this.rsrp1Origin = data.rsrp1 != null ? common.getOriginalFileName(data.rsrp1) : ''
      // this.rsrp1 = data.rsrp1 != null ? data.rsrp1 : ''
      // this.rsrp2Origin = data.rsrp2 != null ? common.getOriginalFileName(data.rsrp2) : ''
      // this.rsrp2 = data.rsrp2 != null ? data.rsrp2 : ''
      // this.rsrp3Origin = data.rsrp3 != null ? common.getOriginalFileName(data.rsrp3) : ''
      // this.rsrp3 = data.rsrp3 != null ? data.rsrp3 : ''
      // this.rsrp4Origin = data.rsrp4 != null ? common.getOriginalFileName(data.rsrp4) : ''
      // this.rsrp4 = data.rsrp4 != null ? data.rsrp4 : ''
      // this.rsrp5Origin = data.rsrp5 != null ? common.getOriginalFileName(data.rsrp5) : ''
      // this.rsrp5 = data.rsrp5 != null ? data.rsrp5 : ''
      this.kamiOrigin = data.kami != null ? common.getOriginalFileName(data.kami) : ''
      this.kami = data.kami != null ? data.kami : ''
      this.ownerMemo = data.ownerMemo != null ? data.ownerMemo : ''
      this.ownerContact = data.ownerContact != null ? data.ownerContact : ''
      this.issueCode = data.issueCode != null ? data.issueCode : ''
      this.etcMemo = data.etcMemo != null ? data.etcMemo : ''
    },
    showPostcodePopup () {
      this.$modal.show('postcodePopup')
    },
    setAddress (data) {
      const addressData = common.getDaumAddressData(data)
      this.postalCode = addressData.postalCode
      this.addressRoad = addressData.addressRoad
      this.addressLot = addressData.addressLot
      this.addressDetails = ''
      this.$modal.hide('postcodePopup')
    },
    uploadFile (type) {
      if (this.$refs[type].files.length !== 1) {
        common.amsAlert('general', '파일을 선택하세요.')
        return
      }
      const file = this.$refs[type].files[0]
      const fileName = file.name
      if (!common.checkValidateLength('max', fileName, 50)) {
        common.amsAlert('general', '파일명은 50자 이내로 설정하세요.')
        return
      }
      if (this.attachmentTypes.includes(type)) {
        this[`${type}Origin`] = fileName
      } else {
        common.amsAlert('general', '잘못된 접근입니다.')
      }
      let path = ''
      if (type === 'kami') {
        path = 'kami'
      } else if (type.includes('rsrp')) {
        path = 'rsrp'
      } else {
        common.amsAlert('general', '잘못된 접근입니다.')
        return
      }
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      let formData = new FormData()
      formData.append('file', file)
      formData.append('path', path)
      axios.post('/api/uploadFile', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': sessionStorage.accessToken,
          'authorization-refresh': sessionStorage.accessTokenRefresh
        }
      }).then(response => {
        console.log('uploadFile', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          if (this.attachmentTypes.includes(type)) {
            this[`${type}`] = response.data.result
          } else {
            common.amsAlert('general', '잘못된 접근입니다.')
          }
        } else {
          alert('파일을 업로드하지 못했습니다.\n잠시 후 다시 시도해주세요.')
        }
      }).catch(response => {
        vueLoadingOverlay.hide()
        console.error(response)
        alert('파일을 업로드하지 못했습니다.\n잠시 후 다시 시도해주세요.')
      })
    },
    deleteFile (type) {
      if (this.attachmentTypes.includes(type)) {
        this[`${type}Origin`] = ''
        this[`${type}`] = ''
      } else {
        common.amsAlert('general', '잘못된 접근입니다.')
      }
    },
    saveShadowQuality () {
      if ((this.mySession.subRole & 4) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      const result = common.checkUserRole(this.mySession, 2, 'add')
      if (!result.code) {
        return
      }
      if (!common.checkValidateData('string', this.meterNum) ||
        !common.checkValidateLength('max', this.meterNum, 30)) {
        common.amsAlert('general', '기기번호(계량기 번호)를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.requestType)) {
        common.amsAlert('general', '요청구분을 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.siteMngName) ||
        !common.checkValidateLength('max', this.siteMngName, 255)) {
        common.amsAlert('general', '현장담당자(이름)를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.siteMngContract) ||
        !common.checkValidateLength('max', this.siteMngContract, 30)) {
        common.amsAlert('general', '현장담당자 연락처를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.postalCode)) {
        common.amsAlert('general', '주소를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.addressDetails)) {
        common.amsAlert('general', '상세주소를 입력해주세요.')
        return
      }
      if (!common.checkValidateLength('max', this.addressDetails, 255)) {
        common.amsAlert('general', '상세주소가 너무 깁니다.')
        return
      }
      if (!common.checkValidateData('string', this.buildingName) ||
        !common.checkValidateLength('max', this.buildingName, 255)) {
        common.amsAlert('general', '상호/건물명을 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.modemPos)) {
        common.amsAlert('general', '모뎀위치를 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.meterPos) ||
        !common.checkValidateLength('max', this.meterPos, 255)) {
        common.amsAlert('general', '계량기 상세 위치를 입력해주세요.')
        return
      }
      let data = {
        sqPid: this.sqPid,
        modemPid: this.modemPid,
        meterNum: this.meterNum,
        requestType: this.requestType,
        siteMngName: this.siteMngName,
        siteMngContract: this.siteMngContract,
        postalCode: this.postalCode,
        addressRoad: this.addressRoad,
        addressLot: this.addressLot,
        addressDetails: this.addressDetails,
        buildingName: this.buildingName,
        modemPos: this.modemPos,
        meterPos: this.meterPos
      }
      if (common.checkValidateData('number', this.signalLevel)) {
        data.signalLevel = this.signalLevel
      }
      if (common.checkValidateData('string', this.rsrp)) {
        data.rsrp = this.rsrp
      }
      // if (common.checkValidateData('string', this.rsrp1)) {
      //   data.rsrp1 = this.rsrp1
      // }
      // if (common.checkValidateData('string', this.rsrp2)) {
      //   data.rsrp2 = this.rsrp2
      // }
      // if (common.checkValidateData('string', this.rsrp3)) {
      //   data.rsrp3 = this.rsrp3
      // }
      // if (common.checkValidateData('string', this.rsrp4)) {
      //   data.rsrp4 = this.rsrp4
      // }
      // if (common.checkValidateData('string', this.rsrp5)) {
      //   data.rsrp5 = this.rsrp5
      // }
      if (common.checkValidateData('string', this.kami)) {
        data.kami = this.kami
      }
      if (common.checkValidateData('string', this.ownerMemo)) {
        if (!common.checkValidateLength('max', this.ownerMemo, 255)) {
          common.amsAlert('general', '건물주/담당자 특이사항이 너무 깁니다.')
          return
        }
        data.ownerMemo = this.ownerMemo
      }
      if (common.checkValidateData('string', this.ownerContact)) {
        data.ownerContact = this.ownerContact
      }
      if (common.checkValidateData('string', this.issueCode)) {
        data.issueCode = this.issueCode
      }
      if (common.checkValidateData('string', this.etcMemo)) {
        if (!common.checkValidateLength('max', this.etcMemo, 1024)) {
          common.amsAlert('general', '기타사항이 너무 깁니다.')
          return
        }
        data.etcMemo = this.etcMemo
      }
      let method = 'put'
      const checkedData = common.checkChangedData(data, this.originData)
      if (this.sqPid != null) {
        method = 'post'
        if (Object.keys(checkedData).length > 0) {
          checkedData.sqPid = this.originData.sqPid
        } else {
          common.amsAlert('general', '수정된 내용이 없습니다.')
          return
        }
      }
      console.log(method, data)
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      shadowQuality.quality(method, data, response => {
        console.log('[음영∙품질 개선] 요청사항 등록/수정', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '요청사항을 저장했습니다.')
          this.hidePopup({type: 'L'})
        } else {
          common.amsAlert('retry', '요청사항을 저장하지 못했습니다.')
        }
      })
    }
  }
}
</script>

<style scoped>
#ShadowQualityRequestPopup .common_bottom_wrap > .btn_bottom {
  height: 46px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px;
}

#ShadowQualityRequestPopup .common_bottom_wrap > .btn_close {
  width: 76px;
  margin: auto auto auto 0;
  color: #36414F;
}

#ShadowQualityRequestPopup .type_form > .common_view_item > div > div:nth-child(1) {
  width: 171px;
}

#ShadowQualityRequestPopup .type_form > .common_view_item > div > div:nth-child(2) {
  display: flex;
  padding-left: 0;
}

#ShadowQualityRequestPopup .type_form > .common_view_item > div > div:nth-child(2) > .type_form_width_100 {
  width: 100%;
}

#ShadowQualityRequestPopup .type_form > .common_view_item > div > div:nth-child(2) > .type_form_width_75 {
  width: 75%;
}

#ShadowQualityRequestPopup .type_form > .common_view_item > div > div:nth-child(2) > .type_form_width_50 {
  width: 50%;
}

#ShadowQualityRequestPopup .type_form > .common_view_item > div > div:nth-child(2) > span {
  display: block;
  flex-shrink: 0;
  margin: auto 0 auto 16px;
  word-break: keep-all;
}

#ShadowQualityRequestPopup .type_form > .common_view_item > div > div:nth-child(2).type_attachment {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

#ShadowQualityRequestPopup .type_attachment > .common_form_input_wrap.type_file {
  display: flex;
  gap: 12px;
}

#ShadowQualityRequestPopup .type_attachment > .common_form_input_wrap.type_file > div {
  flex-shrink: 1;
  width: 100%;
  height: 36px;
  box-sizing: border-box;
}

#ShadowQualityRequestPopup .type_attachment > .common_form_input_wrap.type_file > div > div {
  font-size: 12px;
}

#ShadowQualityRequestPopup .type_attachment > .common_form_input_wrap.type_file > div > div:nth-child(1) {
  flex-shrink: 0;
}

#ShadowQualityRequestPopup .type_attachment > .common_form_input_wrap.type_file > div > div:nth-child(2) {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  text-align: right;
}

#ShadowQualityRequestPopup .type_attachment > .common_form_input_wrap.type_file > .btn_upload,
#ShadowQualityRequestPopup .type_attachment > .common_form_input_wrap.type_file > .btn_delete,
#ShadowQualityRequestPopup .type_attachment > .common_form_input_wrap.type_file > .btn_download {
  flex-shrink: 0;
  width: 67px;
  height: 36px;
  margin: 0;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 34px;
}

#ShadowQualityRequestPopup .type_address {

}

#ShadowQualityRequestPopup .type_address > div {

}

#ShadowQualityRequestPopup .type_address > div:nth-child(1) {

}

#ShadowQualityRequestPopup .type_address > div:nth-child(2) {
  display: flex;
  padding: 0;
  background: none;
}

#ShadowQualityRequestPopup .type_address > div:nth-child(2) > div:nth-child(1) {
  padding: 0;
  background: none;
}

#ShadowQualityRequestPopup .type_address > div:nth-child(2) > div:nth-child(1) > .btn_inner_blue {
  width: 92px;
  height: 36px;
  margin: 0 auto 0 26px;
  background-position: calc(100% - 12px) center;
  font-size: 12px;
  line-height: 36px;
  text-indent: 12px;
}

#ShadowQualityRequestPopup .type_address > div:nth-child(2) > div:nth-child(2) {
  display: flex;
  flex-direction: column;
  padding: 0 26px 14px 0;
  gap: 15px;
}

#ShadowQualityRequestPopup .type_address > div:nth-child(2) > div:nth-child(2) > div {

}

#ShadowQualityRequestPopup .type_address > div:nth-child(2) > div:nth-child(2) > div:nth-child(1) {
  display: flex;
  gap: 20px;
}

#ShadowQualityRequestPopup .type_address > div:nth-child(2) > div:nth-child(2) > div:nth-child(1) > input:nth-child(1) {
  width: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/shadowQuality/ShadowQualityRequestPopup.vue